import { lazy } from 'react';

export const portraitGridComponent = lazy(() => import('./components/Grid/Portrait')) as any;
export const desktopStandardGridComponent = lazy(() => import('./components/Grid/Desktop/Standard')) as any;
export const desktopWideGridComponent = lazy(() => import('./components/Grid/Desktop/Wide')) as any;
